import { createSelector } from '@ngrx/store';

import * as fromFeature from 'src/app/core/store/reducers';

// export const getRouterState = createFeatureSelector<
//   fromRouter.RouterReducerState<RouterReducerState.RouterStateUrl>
// >('routerReducer');

export const getRouterState = createSelector(
  fromFeature.selectCoreState,
  (state: fromFeature.AppState) => state.routerReducer
);
